export default __webpack_public_path__ + "static/media/heroImg.83b9c6b8.gif";